import GameCore from "../GameCore";
import BaseBullet from "./BaseBullet";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";
import Game from "../Game";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class StoneAuraBullet extends BaseBullet {
  private damageTimer: number = 0;

  constructor(
    group: BulletGroup,
    weapon: BaseWeapon,
    indexInWeapon = 0,
    x: number = 0,
    y: number = 0
  ) {
    super(group, weapon, indexInWeapon, "", x, y, SPRITESHEET_KEYS.WEAPONS);
    this.setTexture(SPRITESHEET_KEYS.WEAPONS, SPRITESHEET_FRAMES.WEAPONS.ROCK);
    this.damageTimer = 0;
  }

  Init(x = -1000, y = -1000) {
    super.Init(x, y);
    this.setScale(1.5 * GameCore.PixelScale * this.weapon.PArea);
    this.setDepth(Game.Core.Player.depth - 1);

    // Setup physics body
    if (this.body) {
      const radius = this.width * 0.4;
      this.body.setCircle(radius);
    }
  }

  OnRecycle(): void {
    super.OnRecycle();
    this.setTexture(SPRITESHEET_KEYS.WEAPONS, SPRITESHEET_FRAMES.WEAPONS.ROCK);
    this.damageTimer = 0;
    this.setData("angle", 0);
    this.setData("angleSpeed", 0.01);
    this.setScale(1.5 * GameCore.PixelScale * this.weapon.PArea);
  }

  Update(delta: number = 16.67): void {
    // Bullet movement is handled by the weapon
    // Just rotate the stone for visual effect - frame-rate independent
    const ROTATION_SPEED = 120; // degrees per second (2 * 60fps = 120 degrees/sec)
    const deltaInSeconds = delta / 1000;
    this.angle += ROTATION_SPEED * deltaInSeconds;
  }

  OnHasHitAnObject(enemy: any) {
    const currentTime = Game.Core.scene.time.now;

    // Check damage cooldown to prevent hitting the same enemy too frequently
    if (currentTime - this.damageTimer < 500) {
      return;
    }

    // Update damage timer
    this.damageTimer = currentTime;

    // Flash effect for feedback
    Game.Core.scene.tweens.add({
      targets: this,
      alpha: 0.5,
      duration: 100,
      yoyo: true,
    });

    // Call the parent method to handle penetration logic
    if (!enemy.isDead) {
      this.penetrating--;
    }
  }

  DeSpawn() {
    super.DeSpawn();
  }
}
